// extracted by mini-css-extract-plugin
export var section = "awardsCarousel25-module--section--1Yrmw";
export var thumbnailsContainer = "awardsCarousel25-module--thumbnails-container--3re_s";
export var label = "awardsCarousel25-module--label--1oTFo";
export var thumbnails = "awardsCarousel25-module--thumbnails--345ru";
export var member = "awardsCarousel25-module--member--2eia-";
export var profile = "awardsCarousel25-module--profile--1ykgG";
export var images = "awardsCarousel25-module--images--31f9R";
export var candid = "awardsCarousel25-module--candid--1LzyJ";
export var image = "awardsCarousel25-module--image--3dAct";
export var name = "awardsCarousel25-module--name--8sf6K";
export var title = "awardsCarousel25-module--title--1ET6e";
export var bio = "awardsCarousel25-module--bio--3uU9t";
export var paragraph = "awardsCarousel25-module--paragraph--2bJhq";
export var arrows = "awardsCarousel25-module--arrows--15dS9";
export var left = "awardsCarousel25-module--left--2iUJW";
export var right = "awardsCarousel25-module--right--i1mY1";